import { render, staticRenderFns } from "./Brackets.vue?vue&type=template&id=53d39ff8&scoped=true"
import script from "./Brackets.vue?vue&type=script&lang=js"
export * from "./Brackets.vue?vue&type=script&lang=js"
import style0 from "./Brackets.vue?vue&type=style&index=0&id=53d39ff8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d39ff8",
  null
  
)

export default component.exports